import React from 'react';
import ReactDOM from 'react-dom';
import promiseFinally from 'promise.prototype.finally';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
// import { useStrict } from 'mobx';
// import createBrowserHistory from 'history/createBrowserHistory';
import { Provider } from 'mobx-react';
// import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
// import './assets/lib/normalize.scss';
import './style/style.scss';

import App from './App';

// include store
import appStore from './stores/appStore';
import accountStore from './stores/accountStore';
import lineStore from './stores/lineStore';
import dictStore from './stores/dictStore';
import resultStore from './stores/resultStore';
import financeStore from './stores/financeStore';
import routingStore from './stores/routingStore';
import searchStore from './stores/searchStore';
import totoStore from './stores/totoStore';

// const browserHistory = createBrowserHistory();
// const routingStore = new RouterStore();
const stores = {
  appStore,
  accountStore,
  lineStore: appStore.lineStore,
  dictStore,
  resultStore,
  financeStore,
  routingStore,
  searchStore,
  totoStore,
  igStore: appStore.igStore
};

window.getLang = stores.dictStore.getLang;

// console.log(browserHistory);

// const history = syncHistoryWithStore(browserHistory, routingStore);
// For easier debugging
// window._____APP_STATE_____ = stores;

promiseFinally.shim();
// useStrict(true);

ReactDOM.render((
  <Provider {...stores}>
    <BrowserRouter>
      <Route component={App} />
    </BrowserRouter>
  </Provider>
), document.getElementById('sm'));



// WEBPACK FOOTER //
// ./src/index.js